import React, { useRef, useEffect } from 'react';
import { Form, Input, DatePicker } from '@ss/mtd-react';
import { useRootStore } from '@src/model';
import { observer } from 'mobx-react-lite';
import ModuleView from '../../ModuleView';

const FormItem = Form.Item;

// 仅社招
function Exam(props) {
  const formRefs = useRef<any[]>([]);
  const { data } = props;
  const { socialResumeDetail, socialResumeFormRefStore } = useRootStore();

  const store = socialResumeDetail;
  const storeRef = socialResumeFormRefStore;

  useEffect(() => {
    storeRef.changeRef('resumeExamListRef', formRefs.current);
  }, [data, data?.length]);

  const handleValueChange = (index: string, formItemKey: string, formItemValue: any) => {
    store.setResumeExamList(index, formItemKey, formItemValue);
  };

  return (
    <div className="exam_edit model_edit">
      <div className="model_title">考试</div>
      {data?.map((item, index) => (
        <div className="model_list" key={item.renderId}>
          <Form
            ref={(el) => {
              formRefs.current[index] = el;
            }}
            className="modal_form"
            defaultFieldsValue={item}
            onFieldValueChange={(formItemKey, formItemValue) => handleValueChange(index, formItemKey, formItemValue)}
          >
            <FormItem formItemKey="examName" span="11" labelWidth={0} required message="请填写考试名称">
              <div className="label">
                考试名称<span className="icon">*</span>
              </div>
              <Input toFormItem size="large" placeholder="请输入考试名称" />
            </FormItem>
            <FormItem
              formItemKey="score"
              span="11"
              labelWidth={0}
              rules={[
                { max: 50, message: '不能超过50个字' },
                {
                  validator(rule, value, callback) {
                    if (/^\d+(\.\d+)?$/.test(value)) {
                      callback();
                    } else {
                      callback('请输入数字类型');
                    }
                  },
                },
              ]}
            >
              <div className="label">分数</div>
              <Input toFormItem size="large" placeholder="请输入分数" />
            </FormItem>
            <FormItem formItemKey="examDate" span="11" labelWidth={0}>
              <div className="label">考试时间</div>
              <DatePicker
                toFormItem
                size="large"
                placeholder="请选择"
                format="YYYY/MM"
                valueFormat="timestamp"
                disabledDate={(cur) => {
                  // 当前时间加一个月
                  return cur > Number(new Date()) + 2592000000;
                }}
              />
            </FormItem>
          </Form>
          <div className="delete-list">
            <div onClick={() => store.deleteResumeList('resumeExamList', index)}>删除这段信息</div>
          </div>
        </div>
      ))}
      <div
        className="list_add"
        onClick={() => {
          store.addResumeList('resumeExamList');
        }}
      >
        <div className="add_icon">
          <img src={require('@imgs/add.svg')} alt="" />
        </div>
        添加考试
      </div>
    </div>
  );
}

export default ModuleView(observer(Exam), 'exam');
